export default __webpack_public_path__ + "cffde773830aa88a297bd05f2c6e3dfa.png";